var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "43bab168-e759-441b-9bb1-3ae5e14a43a3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "1a30b347-cb74-4f35-9ce2-8a0486cb63cb",
    cx: 14.99,
    cy: 15,
    r: 11.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#faee7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fbe571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fed659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c557bcd6-979f-46ad-b4ff-1695133bccd9",
    cx: 14.99,
    cy: 15.53,
    r: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3837e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ee7c77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e26964"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "4a3699d2-6c07-41a2-80d5-945a3a41372b",
    cx: 14.99,
    cy: 19.66,
    r: 4.65,
    xlinkHref: "#c557bcd6-979f-46ad-b4ff-1695133bccd9"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconLive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "3b2b1e4e-e604-4763-b4c2-1ae58a6fef8c",
    "data-name": "HEAD",
    d: "M26.9,21.06c-1.19,2-3.88,3.87-7.29,4.78a16.58,16.58,0,0,1-1.78.37l-.5,0c-.55.05-1.14.07-1.75.08l-.59.05h0l-.59-.05c-.52,0-1,0-1.51-.06-.25,0-.5,0-.74-.06a17.1,17.1,0,0,1-1.78-.37c-3.4-.91-6.09-2.77-7.29-4.78a4.13,4.13,0,0,1-.62-2.77c0-.11,0-.21.07-.32a2.78,2.78,0,0,1,.21-.57A3.3,3.3,0,0,0,3,17a3.54,3.54,0,0,0,.22-.57,3.29,3.29,0,0,0,.11-.93c0-.08,0-.16,0-.24s0-.28,0-.42a15.72,15.72,0,0,1,.49-4.34,11.3,11.3,0,0,1,4.36-5,12.44,12.44,0,0,1,4-1.55c.37-.07.75-.13,1.14-.17s.69-.06,1-.08l.66,0h.48c.33,0,.65,0,1,.07a10.43,10.43,0,0,1,1.14.15,12.2,12.2,0,0,1,4.28,1.59,11.18,11.18,0,0,1,4.36,5.05,15.72,15.72,0,0,1,.49,4.34c0,.14,0,.28,0,.42a1.93,1.93,0,0,0,0,.24,3,3,0,0,0,.11.93A2.78,2.78,0,0,0,27,17c.07.14.15.28.23.41a2.78,2.78,0,0,1,.21.57,1.83,1.83,0,0,1,.07.32A4.13,4.13,0,0,1,26.9,21.06Z",
    style: {
      fill: "url(#1a30b347-cb74-4f35-9ce2-8a0486cb63cb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "f0cde68b-388e-4f31-b091-bc239a0ce532",
    "data-name": "SHADOW",
    d: "M26.85,21.06c-1.19,2-3.88,3.87-7.29,4.78a16.58,16.58,0,0,1-1.78.37q-1.05.11-2.25.12l-.59.05h0l-.59-.05c-.79,0-1.55,0-2.25-.12a17.1,17.1,0,0,1-1.78-.37c-3.4-.91-6.09-2.77-7.29-4.78a4.26,4.26,0,0,1-.65-2.52.88.88,0,0,0,0,.16A4.61,4.61,0,0,0,3,20.47c1.2,2,3.89,3.87,7.29,4.78a17.19,17.19,0,0,0,1.78.38c.7.06,1.46.1,2.25.12l.59,0h0l.59,0q1.2,0,2.25-.12a16.65,16.65,0,0,0,1.78-.38c3.41-.91,6.1-2.77,7.29-4.78a4.81,4.81,0,0,0,.64-1.77.86.86,0,0,0,0-.16A4.19,4.19,0,0,1,26.85,21.06Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.24,3.72V5.57a.57.57,0,0,1-.57.57.58.58,0,0,1-.57-.57V3.89C12.47,3.82,12.86,3.76,13.24,3.72Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.42,3.63V5.88a.57.57,0,0,1-.57.57.58.58,0,0,1-.57-.57V3.64l.66,0Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.53,3.85V5.57a.58.58,0,0,1-.57.57.57.57,0,0,1-.57-.57V3.7A10.43,10.43,0,0,1,17.53,3.85Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "2efada1d-6888-4c44-87b0-b7650fd758a0",
    "data-name": "EYEBROWS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.14,9.05c0,.33-.61.86-1.45,1.25a2.62,2.62,0,0,1-1.83.34.26.26,0,0,1-.12-.11c-.15-.32.49-.92,1.43-1.36S10,8.64,10.12,9A.12.12,0,0,1,10.14,9.05Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.69,9.08c0,.33.61.85,1.45,1.25a2.66,2.66,0,0,0,1.83.33.19.19,0,0,0,.12-.11c.15-.31-.49-.92-1.43-1.35S19.85,8.66,19.71,9A.14.14,0,0,0,19.69,9.08Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.86,19.29c.07.28-1.19.83-2.8,1.22S.07,21,0,20.69s1.19-.83,2.81-1.22S5.79,19,5.86,19.29Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39,21.74c.1.27-1,.93-2.51,1.47S1.1,24,1,23.7s1-.92,2.52-1.47S6.3,21.47,6.39,21.74Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.14,19.26c-.07.28,1.18.83,2.8,1.21s3,.47,3,.19-1.18-.83-2.8-1.22S24.2,19,24.14,19.26Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.51,21.76c-.1.26,1,.92,2.52,1.46s2.77.77,2.87.5-1-.93-2.52-1.47S23.61,21.49,23.51,21.76Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "a4da259f-db38-44bd-a3f6-e841e019f56a",
    "data-name": "NOSE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.23,15.53c0,.37-.56.66-1.24.66s-1.25-.29-1.25-.66.56-.65,1.25-.65S16.23,15.17,16.23,15.53Z",
    style: {
      fill: "url(#c557bcd6-979f-46ad-b4ff-1695133bccd9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75,15.26c0,.11-.15.2-.33.2s-.33-.09-.33-.2.15-.21.33-.21S15.75,15.14,15.75,15.26Z",
    style: {
      fill: "#facac2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "b843ac43-46c7-4540-9816-4a4208db8d2c",
    "data-name": "MOUTH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.16,18.5a3.11,3.11,0,0,1-1.66,2.56l-.12.05a5.25,5.25,0,0,1-1.32.48,13.18,13.18,0,0,1-3.07.33,13.19,13.19,0,0,1-3.16-.35,5.4,5.4,0,0,1-1.25-.46l-.1-.05a3.12,3.12,0,0,1-1.67-2.57,4.44,4.44,0,0,0,.52.15,6.91,6.91,0,0,0,1.68.2,5.72,5.72,0,0,0,3.91-1.34.94.94,0,0,0,.1-.1l.05.05A5.63,5.63,0,0,0,19,18.84a7.14,7.14,0,0,0,1.63-.19A4,4,0,0,0,21.16,18.5Z",
    style: {
      fill: "url(#4a3699d2-6c07-41a2-80d5-945a3a41372b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.06,21.59a13.18,13.18,0,0,1-3.07.33,13.19,13.19,0,0,1-3.16-.35,6.39,6.39,0,0,1,3.1-.84A6.3,6.3,0,0,1,18.06,21.59Z",
    style: {
      fill: "#c44756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.64,18.65a3.24,3.24,0,0,1-.82.45c-1.35.16-3-.34-4.78-.34s-3.56.5-4.93.32a2.92,2.92,0,0,1-.78-.44,6.91,6.91,0,0,0,1.68.2,5.72,5.72,0,0,0,3.91-1.34.94.94,0,0,0,.1-.1l.05.05A5.63,5.63,0,0,0,19,18.84,7.14,7.14,0,0,0,20.64,18.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,18.79s.82,1,1,1,.88-.83.88-.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,18.79s-.82,1-1,1-.89-.83-.89-.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "c3f87f46-820a-434e-b3c8-7dbd5ceeccbd",
    "data-name": "EYES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.69,14.57a2.26,2.26,0,0,0-1.22-.78,4.28,4.28,0,0,0-1.64-.13,4.47,4.47,0,0,0-1.63.46,3.1,3.1,0,0,0-.71.49A2.1,2.1,0,0,0,5,15.3a2.22,2.22,0,0,1,.43-.78,3.88,3.88,0,0,1,.66-.62,5.09,5.09,0,0,1,1.68-.75A4.93,4.93,0,0,1,9.62,13a3.34,3.34,0,0,1,1,.26,4.16,4.16,0,0,1,.47.24l.22.16.1.1.06.05,0,0,0,0a.52.52,0,0,1-.73.74Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.43,13.88l0,0,.05-.05.11-.1.22-.16a4,4,0,0,1,.46-.24,3.43,3.43,0,0,1,1-.26,5,5,0,0,1,1.89.12,5,5,0,0,1,1.67.75,3.6,3.6,0,0,1,.67.62,2.22,2.22,0,0,1,.43.78,2.1,2.1,0,0,0-.52-.69,3.34,3.34,0,0,0-.71-.49,4.53,4.53,0,0,0-1.63-.46,4.27,4.27,0,0,0-1.64.13,2.29,2.29,0,0,0-1.23.78.52.52,0,0,1-.72.13.52.52,0,0,1-.13-.73.13.13,0,0,1,.06-.07Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "6ff27ce3-0088-4d4f-8ebb-97a130fd3de3",
    "data-name": "EARS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51,5.84c-.33.34-.65.7-1,1.07L6.46,7A15.52,15.52,0,0,0,5.24,8.7c-.2.32-.39.64-.56,1a12.48,12.48,0,0,0-1.35,4.05,7,7,0,0,1-.5-1A8.76,8.76,0,0,1,2.75,6.2L2.81,6a5.22,5.22,0,0,1,.24-.54l0,0a1.17,1.17,0,0,1,.56-.38h.65a7.8,7.8,0,0,1,2.39.42h0A8.33,8.33,0,0,1,7.51,5.84Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24,8.7c-.2.32-.39.64-.56,1a12.48,12.48,0,0,0-1.35,4.05,7,7,0,0,1-.5-1A8.76,8.76,0,0,1,2.75,6.2,4.05,4.05,0,0,1,5.24,8.7Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.41,5.84c.33.34.65.7,1,1.07a16.12,16.12,0,0,1,1.87,2.75,12.48,12.48,0,0,1,1.35,4.05A8.66,8.66,0,0,0,27.11,6q-.11-.27-.24-.54l0,0a1.17,1.17,0,0,0-.56-.38h-.64a7.81,7.81,0,0,0-2.4.42h0A8.33,8.33,0,0,0,22.41,5.84Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.66,8.76a10.56,10.56,0,0,1,.56,1,12.48,12.48,0,0,1,1.35,4,10.15,10.15,0,0,0,.51-1,8.79,8.79,0,0,0,.07-6.54A4.08,4.08,0,0,0,24.66,8.76Z",
    style: {
      fill: "#f1b02e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLive);
export default __webpack_public_path__ + "static/media/IconLive.1e74ba6b.svg";
export { ForwardRef as ReactComponent };